import React from 'react'
import classnames from 'classnames'
import { Div, ToolTip, Button, Form } from '@driftt/tide-core'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { parse } from 'query-string'

import * as passUtils from 'utils/password'
import EmailInput from 'components/EmailInput'
import Consent from 'components/Consent'
import PasswordInput from 'components/PasswordInput'
import { DynamicNotification } from 'components/DynamicNotification'
import { track } from 'utils/trackingUtils'

const trackFindMyTeamNotification = () => {
  track('Onboarding Find My Team Triggered', {
    context: 'notification triggered'
  })
}

export const INVALID_DOMAINS = [
  '@gmail.',
  '@yahoo.',
  '@hotmail.',
  '@live.',
  '@aol.',
  '@outlook.',
  '@comcast.',
  '@inbox.',
  '@icloud.',
  '@mail.com'
]

const SignupCard = ({
  name,
  email,
  password,
  onNameChange,
  onEmailChange,
  onPasswordChange,
  onContinueClick,
  onFindMyTeamClick,
  onVideoSignInClick,
  disabledEmail,
  validEmail,
  isGdprConsentRequired,
  isGdprConsentGranted,
  setGdprConsentGranted,
  createOrgLoading,
  checkEmailIsSSOEnabledPending,
  splitLoading,
  verifyEmailLoading,
  hideError,
  solvedCaptcha,
  createOrgError,
  onProcessingGoogleCode,
  domainFound,
  hidePopup,
  onCreateNewAccount,
  search,
  verifyEmailError
}) => {
  const { plan } = parse(search)
  const headerCopy = plan ? "Create your Drift account" : "Create your free Drift account"

  const displayToolTip = INVALID_DOMAINS.some(domain => email.includes(domain))

  return (
    <Form className="touchless-start-fields" onSubmit={onContinueClick}>
      <h1 className="touchless-start-header">{headerCopy}</h1>
      <ToolTip
        className="touchless-start-tooltip"
        open={displayToolTip}
        hover={displayToolTip}
        flow='right'
        render={() => "We recommend using a work email in order to get the most out of Drift"}
      />
      <EmailInput
        placeholder="Work email"
        className={cx('touchless-email-input', {
          'touchless-email-input-error':
            !hideError && (!!createOrgError || !validEmail || !!verifyEmailError),
          'touchless-email-input-disable': disabledEmail,
        })}
        onChange={onEmailChange}
        value={email}
        hideError={hideError}
        createOrgError={createOrgError}
        verifyEmailError={verifyEmailError}
        valid={validEmail}
        unique={!createOrgError}
        disabled={disabledEmail}
        type={"text"}
      />
      {(domainFound && !hidePopup) && (
        <DynamicNotification
          type="findMyTeam"
          onClick={onFindMyTeamClick}
          onCreate={onCreateNewAccount}
          onTrack={trackFindMyTeamNotification}
        />
      )}
      <Div className="login-flow">
        {(hidePopup || !domainFound) && (
          <React.Fragment>
            <PasswordInput
              value={password}
              onChange={onPasswordChange}
              label={null}
              experiment={true}
              passwordConfig={passUtils.getDefaultConfig()}
              passwordConfigFetched={true}
              passwordUpdateStatus={null}
            />
            </React.Fragment>
        )}
        {/* Hide recaptcha instead of unmounting so recaptcha lib doesn't uninitialize */}
        <div
          className={classnames(
            'recaptcha-container',
            domainFound && !hidePopup && 'recaptcha-container--hidden')}
        >
          <div id="g-recaptcha" />
        </div>
        {(hidePopup || !domainFound) && (
          <React.Fragment>
            <Button
              submit
              size="large"
              disabled={!passUtils.meetsAllRequirements(password, passUtils.getDefaultConfig()) || !email || (isGdprConsentRequired && !isGdprConsentGranted) || !solvedCaptcha }
              loading={createOrgLoading || checkEmailIsSSOEnabledPending || splitLoading || verifyEmailLoading}
            >
              Create free account
            </Button>
            { isGdprConsentRequired &&
                <Consent
                  checked={isGdprConsentGranted}
                  onChange={() => setGdprConsentGranted(!isGdprConsentGranted)}
                />
            }
            { !disabledEmail && !isGdprConsentRequired &&
                <p className="touchless-start-fields-auth">
                  Sign up with
                <Link className="touchless-start-link" to={'/start'}>
                  Google or Microsoft{' '}
                </Link>
                </p>
            }
          </React.Fragment>
        )}
      </Div>
    </Form>
  )
}

export default SignupCard
